import { apiRequest } from "@services/apiClient";
import homeContentEndpoints from "@services/homeContent/homeContentEndpoints";

function normalizeHomeFromBody(body) {
  if (body?.home && typeof body.home === "object") return body.home;
  if (body && typeof body === "object") return body;
  return null;
}

export async function getHomeContentRequest() {
  const response = await apiRequest(homeContentEndpoints.base);
  return {
    ...response,
    body: normalizeHomeFromBody(response?.body),
  };
}

export async function createHomeContentRequest(payload) {
  const response = await apiRequest(homeContentEndpoints.base, {
    method: "POST",
    body: payload,
  });
  return {
    ...response,
    body: normalizeHomeFromBody(response?.body),
  };
}

export async function updateHomeContentRequest(payload) {
  const response = await apiRequest(homeContentEndpoints.base, {
    method: "PUT",
    body: payload,
  });
  return {
    ...response,
    body: normalizeHomeFromBody(response?.body),
  };
}

export async function saveHomeContentRequest(payload) {
  try {
    return await updateHomeContentRequest(payload);
  } catch (error) {
    if (Number(error?.status) === 404) {
      return createHomeContentRequest(payload);
    }
    throw error;
  }
}
